import { apiGet, apiPost } from './api';

const BASE = '/api/Onboarding';

/** GET /api/Onboarding — the caller's Getting Started checklist, Welcome and role-card flags. */
export function getStatus() {
  return apiGet(BASE);
}

/** POST /api/Onboarding/welcome — answer (or skip) the first-login Welcome dialog. */
export function completeWelcome(siteType) {
  return apiPost(`${BASE}/welcome`, { siteType: siteType || null });
}

/** POST /api/Onboarding/state — save the caller's checklist state (Expanded / Minimised / Dismissed). */
export function setState(state) {
  return apiPost(`${BASE}/state`, { state });
}

/** POST /api/Onboarding/settings-reviewed — tick "Review organisation settings" (idempotent). */
export function markSettingsReviewed() {
  return apiPost(`${BASE}/settings-reviewed`);
}

/** POST /api/Onboarding/role-welcome/dismiss — hide the role welcome card. */
export function dismissRoleWelcome() {
  return apiPost(`${BASE}/role-welcome/dismiss`);
}
